import { useQuery } from '@tanstack/react-query';
import { getPipRunNames } from 'api/pipsRunNames';

export const usePipsRunNames = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['pipRunNames'],
    queryFn: () => getPipRunNames(),
    enabled: enabled,
  });
};
